const saveTitleCrossDetail = (title) => ({
  ...title,
  type: "SAVE_DETAIL_TITLE",
});

export default saveTitleCrossDetail;
